import { StartVerificationSessionResponse, VerificationSession } from 'core/types';
import { apiCall } from 'http/index';

export const startIdentityVerification = async (): Promise<StartVerificationSessionResponse> =>
  apiCall({ method: 'post', url: 'kyc/verification' });

export const getVerificationSession = async (sessionId: string): Promise<VerificationSession> =>
  apiCall({ method: 'get', url: `kyc/verification/${sessionId}` });
